import { createFileRoute } from "@tanstack/react-router";

import { Worlds } from "./-worlds";
import { parseWorldView } from "../../../workspaces/worlds/search";

export const Route = createFileRoute(
  "/_console/p/$org/$project/simulate/assets/$worldId",
)({
  validateSearch: parseWorldView,
  component: SimulationAssetRoute,
});

/** One simulation asset — an environment, a scene or an object — open in the inspector. */
function SimulationAssetRoute() {
  const { worldId } = Route.useParams();
  return <Worlds state={{ ...Route.useSearch(), world: worldId }} />;
}
